module.exports = __webpack_public_path__ + "img/avatar-group.f820c01c.svg";